export const PROFILE_ONBOARDING_TARGETS = {
  resume: "resume-joyride",
  videoProfile: "video-profile-joyride",
  academics: "academics-joyride",
  profileStrength: "profile-strength-joyride",
}
